import Lenis from 'lenis'
import Swiper from 'swiper';
import { animate, scroll } from 'motion'
import { Navigation } from 'swiper/modules';
import Alpine from 'alpinejs';
/* alpine components */
import navigation from './components/navigation.js';
/* styles */
import "swiper/css";
import './styles/index.css'
/* external fonts */
import "@fontsource/playfair-display/400.css";
import "@fontsource/montserrat/400.css";

const lenis = new Lenis();

/**
 * Request Animation Frame Loop
 * @param {number} time - The current time in milliseconds
 * @returns {void}
 */
const raf = (time) => {
  lenis.raf(time);
  requestAnimationFrame(raf);
};

requestAnimationFrame(raf);

const planSwiper = document.getElementById("app-plan-swiper");

if (planSwiper !== null) {
  new Swiper(planSwiper, {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    navigation: {
      prevEl: "#app-plan-prev-button",
      nextEl: "#app-plan-next-button",
      lockClass: "hidden!",
    },
  });
}

const testimonialsSwiper = document.getElementById("app-testimonials-swiper");

if (testimonialsSwiper !== null) {
  new Swiper(testimonialsSwiper, {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,
    breakpoints: {
      940: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    navigation: {
      prevEl: "#app-testimonials-prev-button",
      nextEl: "#app-testimonials-next-button",
      lockClass: "hidden!",
    },
  });
}

const vipSwiper = document.getElementById("app-vipitems-swiper");

if (vipSwiper !== null) {
  new Swiper("#app-vipitems-swiper", {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      940: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
    navigation: {
      prevEl: "#app-vipitems-prev-button",
      nextEl: "#app-vipitems-next-button",
      lockClass: "hidden",
    },
  });
}

const parallaxItems = document.querySelectorAll("[data-motion-parallax-container]");

parallaxItems.forEach((target) => {
  const item = target.querySelector("[data-motion-parallax]");

  if (item !== null) {
    const parallax = animate(item, { top: ["-20%", "20%"] });
    scroll(parallax, { target, offset: ["start end", "end start"] });
  }
});

document.addEventListener("alpine:init", () => {
  Alpine.data("navigation", navigation);
});

Alpine.start();